import React from 'react';
import MuiDialogActions from '@mui/material/DialogActions';
import Dialog, {DialogProps} from 'components/Dialog';
import {Theme} from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import Button from 'components/Button';
import {Trans} from 'react-i18next';
import i18n from 'i18n';

const DialogActions = withStyles((theme: Theme) => ({
   root: {
      margin: 0,
      padding: theme.spacing(1),
   },
}))(MuiDialogActions);

const contentStyles = {flex: '0 1 auto', overflow: 'auto'};

type Props = {
   open?: boolean;
   content?: React.ReactNode;
   title?: string;
   onClose?: () => void;
   maxWidth?: DialogProps['maxWidth'];
};
export const AlertDialog = (props: Props) => {
   const {open = true, content, title = i18n.t('Alert'), onClose, maxWidth} = props;
   return (
      <Dialog header={title} open={open} maxWidth={maxWidth} close={onClose}>
         <div style={contentStyles}>{content}</div>
         <DialogActions>
            <Button onClick={onClose} color="primary">
               <Trans>Close</Trans>
            </Button>
         </DialogActions>
      </Dialog>
   );
};
